import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {withRouter} from 'react-router-dom';
import ReactHighcharts from 'react-highcharts';
import * as AdminActions from '../../store/actions/adminActions';
import Boundary from '../Boundary.js';
import Browsers from './Browsers';

class Demographics extends Component {
    componentDidMount(){
        this.init();
    }

    componentDidUpdate(props){
        if(props.match.params.courseId !== this.props.match.params.courseId){
            this.init();
        }
    }

    init = () => {
        // console.log("Initting");

        this.props.getDemographics(this.props.match.params.courseId, 1, this.props.user.user.id, this.props.user.id);


    }

    
    render(){
        return (
            <li className="dd-item dd3-item" data-id="13">
                <div className="dd-handle dd3-handle"></div>
                <div className="dd3-content">


                    <div className="row">
                    {this.props.match.params.courseId ?
                        <div className="col-sm-8">
                            <div className="panel customPanel">
                            <div className="panel-heading border-bottom panel-heading-with-subtext">
                                <h3 className="panel-title">Demographics</h3>
                            </div>
                            <div className="panel-body no-padding">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <Boundary>
                                            {!this.props.engagementChartsLoading['demographics'] ?
                                                <div id="DemoGraph" >

                                                    {this.props.engagementCharts['demographics'] ?
                                                        <ReactHighcharts
                                                            config={this.props.engagementCharts['demographics']}
                                                            isPureConfig={true}
                                                            neverReflow={true}
                                                            ref="chartde"
                                                        />
                                                        :
                                                        null
                                                    }
                                                </div>
                                            : null
                                            }
                                        </Boundary>
                                    </div>

                                    <div className="col-sm-4">
                                        <Boundary>
                                            {!this.props.engagementChartsLoading['demographicsPie'] ?
                                                <div id="DemoGraph2" >

                                                    {this.props.engagementCharts['demographicsPie'] ?
                                                        <ReactHighcharts
                                                            config={this.props.engagementCharts['demographicsPie']}
                                                            isPureConfig={true}
                                                            neverReflow={true}
                                                            ref="chartde2"
                                                        />
                                                        :
                                                        null
                                                    }
                                                </div>
                                            : null
                                            }
                                        </Boundary>
                                    </div>
                                </div>

                                

                                  
                                </div>


                                <div className="panel-footer">
                                    <div className="w-200">
                                        <div className="form-select-overlay ">
                                            <select value={this.props.engagementChartsLength['demographics']} onChange={e => {
                                                e.preventDefault();
    
                                                this.props.getDemographics(this.props.match.params.courseId, e.target.value, this.props.user.user.id, this.props.user.id);
                                            }} className="form-control" required="required">
                                                <option value={1}>Yesterday</option>
                                                <option value={2}>2 day</option>
                                                <option value={7}>1 Week</option>
                                                <option value={30}>1 Month</option>
                                                <option value={365}>1 Year</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        
                        </div>
            : null}
                        <div className="col-sm-4">
   
                                    <Browsers />
         
                        </div>
                    </div>
                    
                    
                </div>
            </li>
        )
    }
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getDemographics: (courseId, length, userId, token) => {
        dispatch(AdminActions.getEngagementChart('demographics', length, courseId, userId, token));
        dispatch(AdminActions.getEngagementChart('demographicsPie', length, courseId, userId, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Demographics));


// WEBPACK FOOTER //
// ./src/components/AdminConsole/Demographics.js